module.exports = __webpack_public_path__ + "static/media/add-time.407c6daa.svg";